function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-lines */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {

  useLoaderData,

  useBlocker,
  Link,

  useFetcher } from
'react-router-dom';
import { InformationCircleIcon } from '@heroicons/react/20/solid';

import { useForm } from 'react-hook-form';
import { useSetAtom } from 'jotai';
import { Translate } from "../../../../I18N";
import { advancedSort } from "../../../../utils/advancedSort";

import { ConfirmNavigationModal, InputField } from "../../../Components/Forms";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import RenderIfVisible from 'react-render-if-visible';
import { Button, ToggleButton } from "../../../Components/UI";
import * as translationsAPI from "../../../api/translations";
import * as settingsAPI from "../../../api/settings";
import { notificationAtom } from "../../../atoms";
import { availableLanguages } from "../../../../../shared/language";

import { FetchResponseError } from "../../../../../shared/JSONRequest";
import { LanguagePill } from "./components/LanguagePill";

const editTranslationsLoader =
(headers) =>
async ({ params }) => {
  const translations = await translationsAPI.get(headers, params);
  const settings = await settingsAPI.get(headers);

  const sortedTranslations = translations.map((language) => {
    const sortedContexts = language.contexts.map((context) => {
      const sortedContextKeys = advancedSort(Object.keys(context.values));

      const sortedContext = sortedContextKeys.reduce((results, contextKey) => {
        const value = context.values[contextKey];
        return _objectSpread(_objectSpread({}, results), {}, { [contextKey]: value });
      }, {});

      return _objectSpread(_objectSpread({}, context), {}, { values: sortedContext });
    });

    return _objectSpread(_objectSpread({}, language), {}, { contexts: sortedContexts });
  });

  return { translations: sortedTranslations, settings };
};

const editTranslationsAction =
() =>
async ({ params, request }) => {
  const formData = await request.formData();
  const formIntent = formData.get('intent');
  const { context } = params;

  if (formIntent === 'form-submit' && context) {
    const formValues = formData.get('data');
    return translationsAPI.post(JSON.parse(formValues), context);
  }

  if (formIntent === 'file-upload') {
    const file = formData.get('data');
    return translationsAPI.importTranslations(file, 'System');
  }

  return null;
};







const prepareValuesToSave = (
data,
currentTranslations) =>

data.map((language, index) => {
  const values = Object.values(language.values).reduce(
    (result, value) => _objectSpread(_objectSpread({},
    result), {}, {
      [value.key]: value.value }),

    {}
  );
  return _objectSpread(_objectSpread({},
  currentTranslations[index]), {}, {
    contexts: [_objectSpread(_objectSpread({}, currentTranslations[index].contexts[0]), {}, { values })] });

});

const composeTableValues = (formValues, termIndex) =>
formValues.map((language, languageIndex) => {var _availableLanguages$f, _formValues$languageI;
  const languageLabel = (_availableLanguages$f = availableLanguages.find(
    (availableLanguage) => availableLanguage.key === language.locale
  )) === null || _availableLanguages$f === void 0 ? void 0 : _availableLanguages$f.localized_label;
  return {
    language: languageLabel,
    translationStatus: {
      languageKey: language.locale,
      status: ((_formValues$languageI = formValues[languageIndex].values[termIndex]) === null || _formValues$languageI === void 0 ? void 0 : _formValues$languageI.translationStatus) || 'untranslated'
    },
    fieldKey: `formValues.${languageIndex}.values.${termIndex}.value`
  };
});

const getTranslationStatus = (
defaultLanguageValues,
evaluatedTerm,
currentLanguageKey,
defaultLanguageKey) =>
{
  const isUntranslated =
  defaultLanguageValues[evaluatedTerm.key] === evaluatedTerm.value &&
  defaultLanguageKey !== currentLanguageKey;
  const isDefaultLanguage = defaultLanguageKey === currentLanguageKey;

  if (isUntranslated) return 'untranslated';
  if (isDefaultLanguage) return 'defaultLanguage';
  return 'translated';
};

const prepareFormValues = (translations, defaultLanguageKey) => {var _translations$find;
  const defaultLanguageValues = (_translations$find = translations.find(
    (language) => language.locale === defaultLanguageKey
  )) === null || _translations$find === void 0 ? void 0 : _translations$find.contexts[0].values;

  return translations.map((language) => {var _language$_id;
    const values = Object.entries(language.contexts[0].values || {}).reduce(
      (result, [key, value], index) => _objectSpread(_objectSpread({},
      result), {}, {
        [index]: {
          key,
          value,
          translationStatus: getTranslationStatus(
            defaultLanguageValues || {},
            { key, value },
            language.locale,
            defaultLanguageKey
          )
        } }),

      {}
    );
    return { _id: (_language$_id = language._id) === null || _language$_id === void 0 ? void 0 : _language$_id.toString(), locale: language.locale, values };
  });
};

const getContextInfo = (translations) => {
  const contextTerms = Object.keys(translations[0].contexts[0].values || {});
  const { label: contextLabel, id: contextId } = translations[0].contexts[0];
  return { contextTerms, contextLabel, contextId };
};

const filterTableValues = (values) =>
values.filter((value) => value.translationStatus.status !== 'translated');

const calculateTableData = (terms, formValues, hideTranslated) =>
terms.
map((term, index) => {
  let values = composeTableValues(formValues, index);
  if (hideTranslated) values = filterTableValues(values);
  if (values.length === 1 && hideTranslated) return undefined;
  return { [term]: values };
}).
filter((v) => v);

// eslint-disable-next-line max-statements
const EditTranslations = () => {var _settings$languages;
  const { translations, settings } = useLoaderData();




  const [hideTranslated, setHideTranslated] = useState(false);
  const fetcher = useFetcher();
  const setNotifications = useSetAtom(notificationAtom);
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = useRef(null);

  const isSubmitting = fetcher.state === 'submitting';
  const { contextTerms, contextLabel, contextId } = getContextInfo(translations);
  const defaultLanguage = settings === null || settings === void 0 ? void 0 : (_settings$languages = settings.languages) === null || _settings$languages === void 0 ? void 0 : _settings$languages.find((language) => language.default);
  const defaultFormValues = prepareFormValues(translations, (defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.key) || 'en');
  const tablesData = useMemo(
    () => calculateTableData(contextTerms, defaultFormValues, hideTranslated),
    [contextTerms, defaultFormValues, hideTranslated]
  );

  const {
    register,
    handleSubmit,
    setValue,
    getFieldState,
    reset,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { dirtyFields, isSubmitting: formIsSubmitting, isSubmitSuccessful }
  } = useForm({
    defaultValues: { formValues: defaultFormValues },
    mode: 'onSubmit'
  });

  const isDirtyAlt = !!Object.keys(dirtyFields).length;
  const blocker = useBlocker(isDirtyAlt && !formIsSubmitting);

  React.useEffect(() => {
    if (isSubmitSuccessful) {
      reset({}, { keepValues: true });
    }
  }, [isSubmitSuccessful, reset]);

  useMemo(() => {
    if (blocker.state === 'blocked') {
      setShowModal(true);
    }
  }, [blocker, setShowModal]);

  useEffect(() => {var _fetcher$formData, _fetcher$formData2, _fetcher$data$json, _fetcher$data$json2;
    switch (true) {
      case ((_fetcher$formData = fetcher.formData) === null || _fetcher$formData === void 0 ? void 0 : _fetcher$formData.get('intent')) === 'form-submit' && Array.isArray(fetcher.data):
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Translations saved")
        });
        break;

      case ((_fetcher$formData2 = fetcher.formData) === null || _fetcher$formData2 === void 0 ? void 0 : _fetcher$formData2.get('intent')) === 'file-upload' && Array.isArray(fetcher.data):
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Translations imported.")
        });
        break;

      case fetcher.data instanceof FetchResponseError:
        setNotifications({
          type: 'error',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
          details: (_fetcher$data$json = fetcher.data.json) !== null && _fetcher$data$json !== void 0 && _fetcher$data$json.prettyMessage ? (_fetcher$data$json2 = fetcher.data.json) === null || _fetcher$data$json2 === void 0 ? void 0 : _fetcher$data$json2.prettyMessage : undefined
        });
        break;

      default:
        break;
    }
  }, [fetcher.data, fetcher.formData, setNotifications]);

  const formSubmit = async (data) => {
    const formData = new FormData();
    const values = prepareValuesToSave(data.formValues, translations);
    formData.set('intent', 'form-submit');
    formData.set('data', JSON.stringify(values));
    fetcher.submit(formData, { method: 'post' });
    reset({}, { keepValues: true });
  };

  const importFile = async (event) => {var _event$target$files;
    const file = (_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];

    if (file) {
      const formData = new FormData();
      formData.set('intent', 'file-upload');
      formData.set('data', file);
      fetcher.submit(formData, { method: 'post', encType: 'multipart/form-data' });
      reset({}, { keepValues: true });
    }
  };

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-translations-edit" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      path: new Map([['Translations', '/settings/translations']]),
      title: contextLabel,
      contextId: contextId }
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center w-full gap-4 pt-5 mb-4" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(ToggleButton, {
      className: "px-5 pt-5",
      onToggle: () => setHideTranslated(!hideTranslated) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "pl-1 text-sm text-gray-700" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Untranslated Terms")
    )
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-grow" }, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(formSubmit), id: "edit-translations" }, void 0,
    tablesData !== null && tablesData !== void 0 && tablesData.length ?
    tablesData === null || tablesData === void 0 ? void 0 : tablesData.map((tableData) => {
      if (!tableData) return null;
      const [title] = Object.keys(tableData);
      const values = tableData[title];
      return (/*#__PURE__*/
        _jsx(RenderIfVisible, {}, title, /*#__PURE__*/
        _jsx("div", { className: "relative w-full mb-4 border rounded-md shadow-sm border-gray-50" }, void 0, /*#__PURE__*/
        _jsx("table", { className: "w-full text-sm text-left", "data-testid": "table" }, void 0,
        title && /*#__PURE__*/
        _jsx("caption", { className: "p-4 text-base font-semibold text-left text-gray-900 bg-white" }, void 0,
        title
        ), /*#__PURE__*/

        _jsx("thead", { className: "text-xs text-gray-500 uppercase bg-gray-50" }, void 0, /*#__PURE__*/
        _jsx("tr", { className: "border-b" }, void 0, /*#__PURE__*/
        _jsx("th", { scope: "col", className: "px-6 py-3" }, void 0, /*#__PURE__*/
        _jsx("div", { className: "inline-flex" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Language")
        )
        ), /*#__PURE__*/
        _jsx("th", { scope: "col", className: "px-6 py-3" }, void 0, /*#__PURE__*/
        _jsx("div", { className: "inline-flex" }, void 0, /*#__PURE__*/
        _jsx(Translate, { className: "sr-only" }, void 0, "Language Code")
        )
        ), /*#__PURE__*/
        _jsx("th", { scope: "col", className: "w-full px-6 py-3" }, void 0, /*#__PURE__*/
        _jsx("div", { className: "inline-flex" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Value")
        )
        )
        )
        ), /*#__PURE__*/
        _jsx("tbody", {}, void 0,
        values.map((value) => {var _getFieldState;
          const hasErrors = Boolean((_getFieldState =
          getFieldState(value.fieldKey)) === null || _getFieldState === void 0 ? void 0 : _getFieldState.error
          );
          return (/*#__PURE__*/
            _jsx("tr", {}, void 0, /*#__PURE__*/
            _jsx("td", { className: "px-6 py-2" }, void 0, value.language), /*#__PURE__*/
            _jsx("td", { className: "px-6 py-2" }, void 0, /*#__PURE__*/
            _jsx(LanguagePill, {
              languageKey: value.translationStatus.languageKey,
              status: value.translationStatus.status }
            )
            ), /*#__PURE__*/
            _jsx("td", { className: "px-6 py-2" }, void 0, /*#__PURE__*/
            React.createElement(InputField, _extends({
              id: value.fieldKey,
              hideLabel: true,
              disabled: isSubmitting,
              clearFieldAction: () =>
              setValue(value.fieldKey, '', { shouldDirty: true }),

              hasErrors: hasErrors,
              errorMessage:
              hasErrors ? /*#__PURE__*/
              _jsx(Translate, {}, void 0, "This field is required") :

              '' },


            register(value.fieldKey, { required: true }))
            )
            )
            ));

        })
        )
        )
        )
        ));

    }) : /*#__PURE__*/

    _jsx("div", { className: "flex items-center gap-2 p-4 border rounded-md border-gray-50 bg-primary-50" }, void 0, /*#__PURE__*/
    _jsx(InformationCircleIcon, { className: "w-10 text-primary-800" }), /*#__PURE__*/
    _jsx("span", { className: "text-primary-800" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "There are no untranslated terms")
    )
    )

    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-end gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex-1" }, void 0,
    contextId === 'System' && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      type: "button",
      disabled: isSubmitting,
      onClick: () => {var _fileInputRef$current;return (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();} }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Import")
    ), /*#__PURE__*/
    React.createElement("input", {
      ref: fileInputRef,
      type: "file",
      accept: "text/csv",
      className: "hidden",
      onChange: importFile }
    )
    )

    ), /*#__PURE__*/
    _jsx(Link, { to: "/settings/translations" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", type: "button", disabled: isSubmitting }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    )
    ), /*#__PURE__*/
    _jsx(Button, { type: "submit", disabled: isSubmitting, form: "edit-translations" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    ),

    showModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowModal, onConfirm: blocker.proceed })

    ));

};

export { EditTranslations, editTranslationsLoader, editTranslationsAction };